import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';
import { AcmHasLayout } from '../../models/loyalty-acm.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltyAcmLayoutService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService
  ) { }

  get(acmId, layoutId): Observable<AcmHasLayout> {
    return this.http.get(this.baseUrl + '/acm/' + acmId + '/layout/' + layoutId);
  }

  list(acmId, offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable<{ data: Array<AcmHasLayout>, metadata: ListMetadata }> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    if (offset !== null) {
      params.set('offset', offset.toString());
    }
    if (limit !== null) {
      params.set('limit', limit.toString());
    }

    return this.http.getPaged(this.baseUrl + '/acm/' + acmId + '/layout?' + params.toString());
  }

  update(AcmLayout: AcmHasLayout): Observable<AcmHasLayout> {
    return this.http.put(this.baseUrl + '/acm/' + AcmLayout.acm_id + '/layout/' + AcmLayout.layout_id, AcmLayout);
  }

  create(AcmLayout: AcmHasLayout): Observable<AcmHasLayout> {
    return this.http.post(this.baseUrl + '/acm/' + AcmLayout.acm_id + '/layout/' + AcmLayout.layout_id, AcmLayout);
  }

  remove(acmId, layoutId): Observable<AcmHasLayout> {
    return this.http.delete(this.baseUrl + '/acm/' + acmId + '/layout/' + layoutId);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/AcmLayoutDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-acm-layout.service.ts